const BUYER = 'BUYER';
const SUPPLIER = 'SUPPLIER';

function getWorkspaceCompany(snapshot = {}) {
  return snapshot.context?.company || (snapshot.companies || []).find(company => company.id === snapshot.context?.companyId) || null;
}

function getWorkspaceRoles(snapshot = {}) {
  const roles = getWorkspaceCompany(snapshot)?.roles || [];
  const available = [BUYER, SUPPLIER].filter(role => roles.includes(role));
  return available.length ? available : [BUYER];
}

function getWorkspaceRole(snapshot = {}, preferredRole = snapshot.workspaceRole) {
  const available = getWorkspaceRoles(snapshot);
  if (available.includes(preferredRole)) return preferredRole;
  if (snapshot.context?.role === 'PRODUCTION' && available.includes(SUPPLIER)) return SUPPLIER;
  return available[0];
}

function getWorkspaceNavigation(role) {
  return role === SUPPLIER ? [
    { id: 'dashboard', label: '대시보드', icon: 'LayoutDashboard' },
    { id: 'inquiries', label: '받은 의뢰', icon: 'ClipboardList' },
    { id: 'quotes', label: '제출 견적', icon: 'FileText' },
    { id: 'orders', label: '수주 · 공급', icon: 'Package' },
    { id: 'schedule', label: '생산 · 출고 일정', icon: 'CalendarDays' },
    { id: 'meetings', label: '미팅', icon: 'Users' },
    { id: 'company', label: '기업 정보 · 역량', icon: 'Factory' },
  ] : [
    { id: 'dashboard', label: '대시보드', icon: 'LayoutDashboard' },
    { id: 'inquiries', label: '제조 의뢰', icon: 'ClipboardList' },
    { id: 'suppliers', label: '제조사 찾기', icon: 'Factory' },
    { id: 'quotes', label: '받은 견적', icon: 'FileText' },
    { id: 'orders', label: '주문 · 납품', icon: 'Package' },
    { id: 'schedule', label: '납품 일정', icon: 'CalendarDays' },
    { id: 'meetings', label: '미팅', icon: 'Users' },
  ];
}

function getWorkspaceData(snapshot = {}, role = getWorkspaceRole(snapshot)) {
  const companyId = snapshot.context?.companyId;
  const party = role === SUPPLIER ? 'supplierCompanyId' : 'buyerCompanyId';
  const rfqs = (snapshot.rfqs || []).filter(rfq => rfq[party] === companyId);
  const incomingIds = new Set(rfqs.map(rfq => rfq.inquiryId));
  const orders = (snapshot.orders || []).filter(order => order[party] === companyId);
  const orderIds = new Set(orders.map(order => order.id));
  return {
    inquiries: (snapshot.inquiries || []).filter(inquiry => role === SUPPLIER ? incomingIds.has(inquiry.id) : inquiry.buyerCompanyId === companyId),
    rfqs,
    quotes: (snapshot.quotes || []).filter(quote => quote[party] === companyId),
    orders,
    schedules: (snapshot.schedules || []).filter(schedule => orderIds.has(schedule.orderId)),
  };
}

function workspacePreferenceKey(uid, companyId) {
  return `linkflow-workspace-role:${uid || 'anonymous'}:${companyId || 'none'}`;
}

function readWorkspacePreference(key) {
  try { const value = localStorage.getItem(key); return [BUYER, SUPPLIER].includes(value) ? value : null; }
  catch { return null; }
}

module.exports = { getWorkspaceCompany, getWorkspaceRoles, getWorkspaceRole, getWorkspaceNavigation, getWorkspaceData, workspacePreferenceKey, readWorkspacePreference };
